import { Pipe, PipeTransform } from '@angular/core';
import { Player } from '../models/player.model';
import { FormGroup } from '@angular/forms';

@Pipe({
  name: 'byname',
  pure: false
})
export class ByNamePipe implements PipeTransform {
  transform(items: Player[], filter: string): any {
    if (!items || !filter) {
      return items;
    }
    filter = filter.toLowerCase();
    // filter items array, items which match and return true will be
    // kept, false will be filtered out
    return items.filter(item => item.firstName.toLowerCase().indexOf(filter) !== -1 || item.lastName.toLowerCase().indexOf(filter) !== -1);
  }
}

@Pipe({
  name: 'bynamerank',
  pure: false
})
export class ByNamePipeRank implements PipeTransform {
  transform(items: FormGroup[], filter: string): any {
    if (!items || !filter) {
      return items;
    }
    filter = filter.toLowerCase();
    return items.filter(item => (item.controls.player.value as any).firstName.toLowerCase().indexOf(filter) !== -1 ||
    (item.controls.player.value as any).lastName.toLowerCase().indexOf(filter) !== -1);
  }
}
